import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Background } from './Background';
import { Preview } from './Preview';

// общая основа для превью, сфокусированных на части бодиграфа (канал, ворота, центр):
// подсвеченные центры остаются в цвете, остальные бледнеют, а сам бодиграф сдвигается и масштабируется

const sizes = {
  md: {
    width: '12em',
    height: '12em',
    bodyWidth: 600,
  },
  sm: {
    width: '6em',
    height: '6em',
    bodyWidth: 300,
  },
}

// насколько надо сдвинуть бодиграф, чтобы центр оказался в середине превью
const focusPosition = {
  "sm": {
    "HD": {
      x: '0%',
      y: '20.5%',
    },
    "AA": {
      x: '0%',
      y: '14.5%',
    },
    "TT": {
      x: '0%',
      y: '6.5%',
    },
    "GC": {
      x: '0%',
      y: '-2%',
    },
    "HT": {
      x: '-17%',
      y: '-6.2%',
    },
    "SL": {
      x: '0%',
      y: '-13%',
    },
    "SN": {
      x: '29.5%',
      y: '-12.5%',
    },
    "SP": {
      x: '-28%',
      y: '-12.5%',
    },
    "RT": {
      x: '0%',
      y: '-20.6%',
    },
  },
  "md": {
    "HD": {
      x: '0%',
      y: '39%',
    },
    "AA": {
      x: '0%',
      y: '29%',
    },
    "TT": {
      x: '0%',
      y: '12%',
    },
    "GC": {
      x: '0%',
      y: '-4%',
    },
    "HT": {
      x: '-17%',
      y: '-12%',
    },
    "SL": {
      x: '0%',
      y: '-22%',
    },
    "SN": {
      x: '29%',
      y: '-23%',
    },
    "SP": {
      x: '-28%',
      y: '-24%',
    },
    "RT": {
      x: '0%',
      y: '-40%',
    },
  }
}

export function FocusedBody({
  style = {},
  design,
  size = 'md',
  width = '12em',
  height = '12em',
  zoom = 1,
  numbers = true,
  highlightedCenters = [],
  highlightedGate = [],
}) {

  // если центров несколько (канал), целимся в середину между ними
  const focusOffset = useMemo(() => {
    const positions = highlightedCenters
      .map(center => focusPosition[size] && focusPosition[size][center])
      .filter(Boolean);
    if (!positions.length) return { x: '0%', y: '0%' };
    const middle = (axis) =>
      positions.reduce((sum, one) => sum + parseFloat(one[axis]), 0) / positions.length;
    return { x: `${middle('x')}%`, y: `${middle('y')}%` };
  }, [highlightedCenters, size]);

  return (
    <>
      <CSSbody1
        className='x_focused_body'
        width={!style.width ? sizes[size]['width'] : style.width ? style.width : width}
        height={!style.height ? sizes[size]['height'] : style.height ? style.height : width}
        style={{ ...style }}
      >

        <CSSbodyInner
          {...focusOffset}
          zoom={zoom}
        >
          <Preview
            numbers={numbers}
            simplified={false}
            highlighted={highlightedCenters}
            highlightedGate={highlightedGate}
            width={160}
            height={200}
            design={design}
          />
        </CSSbodyInner>
        <Background style={{ zIndex: 0 }} aura={false} design={design} />
      </CSSbody1>
    </>
  )
}


const CSSbody1 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: ${props => props.width};
  height: ${props => props.height};
`
const CSSbodyInner = styled.div`
  /* the transform makes this a stacking context, so it needs to be lifted above Background */
  position: relative;
  z-index: 1;
  /* scale goes first so the offset is scaled too and the channel stays centered */
  transform: scale(${props => props.zoom}) translate(${props => props.x}, ${props => props.y});
`
